export default __webpack_public_path__ + "media/components/sessions/registration-form/img/gauge_Icon_2-f635aa3602cd5841015e9f2c5769d373.svg";